import { render, staticRenderFns } from "./dynamicTags.vue?vue&type=template&id=e065a736&scoped=true&"
import script from "./dynamicTags.vue?vue&type=script&lang=js&"
export * from "./dynamicTags.vue?vue&type=script&lang=js&"
import style0 from "./dynamicTags.vue?vue&type=style&index=0&id=e065a736&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e065a736",
  null
  
)

export default component.exports